import { useEffect } from 'react';

const useOutsideClick = (ref, handler) => {
  useEffect(() => {
    // Проверка на наличие рефа
    if (!ref.current) return;

    const listener = (event) => {
      // Проверяем, находится ли клик вне элемента
      if (!ref.current.contains(event.target)) {
        handler();
      }
    };

    // Добавляем слушатели, если реф существует
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    // Убираем слушатели при размонтировании компонента
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]); // добавляем зависимость для ref и handler
};

export default useOutsideClick;
